<template>
  <div class="group_list">
    <div class="response_table">
      <div v-if="loading">
        <div class="spinner">
          <scale-loader />
        </div>
      </div>

      <table v-else>
        <thead>
          <tr>
            <th class="text-left" scope="col"> {{ translate('diadoc.groups.name') }} </th>
            <th class="text-left" scope="col"> {{ translate('diadoc.groups.code') }} </th>
            <th scope="col"> {{ translate('diadoc.groups.is_active') }} </th>
          </tr>
        </thead>
        <tbody>
          <tr
              class="group_item pointer"
              v-for="(group,key) in groups"
              :key="group.id"
          >
            <td class="text-left" :data-label="translate('diadoc.groups.name')"> {{ group.name }} </td>
            <td class="text-left" :data-label="translate('diadoc.groups.code')"> {{ group.code }} </td>
            <td :data-label="translate('diadoc.groups.is_active')"> {{ group.is_active ? translate('yes') : translate('no') }} </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DiadocGroups',
  props:{
    groups: Array,
  },
  components: {
  },
  data () {
    return {
      loading: false,
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
    }
  },
}
</script>

<style lang="scss" scoped>
  .group_list {
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;

    .header{
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-bottom: 10px;
      .buttons{
        span{
          display: flex;
          gap: 5px;
        }
      }
    }

    .response_table{
      //padding: 10px 0 0;
      padding: 0;
      th.text-left{
        text-align: left;
      }
      tbody{
        tr{
          font-size: 12px;
          &:hover{
            background-color: #eeeeee;
          }
        }

        .text-left{
          text-align: left;
        }

        .limit{
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 1.5em;
          max-height: 3em;
          margin-bottom: 0;
          font-size: 12px;
        }
      }
    }
  }
</style>
